export const WISHLIST_ACTIONS = {
  ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
  REMOVE_FROM_WISHLIST: "REMOVE_FROM_WISHLIST",
  SHOW_WISHLIST: "SHOW_WISHLIST",
  CLEAR_WISHLIST: "CLEAR_WISHLIST",
};
